import { FieldInputProps } from 'react-final-form'

import FormItem from 'common/components/FormItem'
import Input from 'common/components/Input'

import { CommonFieldPropsGeneric, TextType } from '../interfaces'

const ERROR_MESSAGES = {
  required: 'Please enter an answer.',
}

type Props = FieldInputProps<string, HTMLElement> &
  CommonFieldPropsGeneric & {
    value: TextType['value']
    componentProps?: TextType['componentProps']
  }

const Text = ({
  label,
  name,
  value,
  errorCode,
  tooltip,
  isDisabled,
  placeholder,
  componentProps,
  onChange,
  onBlur,
}: Props) => {
  return (
    <FormItem
      label={label}
      guidingText={tooltip}
      htmlFor={name}
      error={errorCode ? ERROR_MESSAGES[errorCode] : undefined}
      style={componentProps?.style}
    >
      <Input
        type="text"
        id={name}
        name={name}
        variant="default"
        placeholder={placeholder}
        disabled={isDisabled}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
        value={value}
      />
    </FormItem>
  )
}

export default Text
